const blockTableOverFlowReachedEnd = (block, wrapper) => {
  const scrollEnd = Math.abs(wrapper.scrollLeft) === wrapper.scrollWidth - wrapper.clientWidth
  if (scrollEnd) {
    if (!block.classList.contains('table-overflow--scroll-end')) {
      block.classList.add('table-overflow--scroll-end')
    }
  } else {
    if (block.classList.contains('table-overflow--scroll-end')) {
      block.classList.remove('table-overflow--scroll-end')
    }
  }
}

export const blockTable = () => {
  const blocks = document.querySelectorAll('.wp-block-table')
  if (blocks.length) {
    blocks.forEach((block) => {
      const table = block.querySelector('table')
      const cols = block.querySelectorAll('thead tr th')
      if (table && cols.length && cols.length > 2) {
        // Wrap la table dans une div
        const wrapper = document.createElement('div')
        wrapper.classList.add('table-overflow__wrapper')
        table.parentNode.insertBefore(wrapper, table)
        wrapper.appendChild(table)

        // Check if the table has scrolled all he way to the end
        wrapper.addEventListener('scroll', () => {
          blockTableOverFlowReachedEnd(block, wrapper)
        })

        setTimeout(() => {
          blockTableOverFlowReachedEnd(block, wrapper)
        }, 0)

        block.classList.add('table-overflow')
      }
    })
  }
}
